import { Circle } from "lucide-react";

const STATUS = {
  FREE: { label: "Wahl frei", dot: "#4fb477" },
  RESERVED: { label: "Reserviert", dot: "#d69a23" },
  TATTOOED: { label: "Vergeben", dot: "#8d7565" },
  DISABLED: { label: "Vergeben", dot: "#8d7565" },
};

export const CurioStatusPlate = ({ number, status, priceLabel, hasPhoto, onViewPhoto, loading }) => {
  const s = STATUS[status] || STATUS.FREE;
  return (
    <div className="brass-plate" data-testid="status-plate-container">
      <div className="status-line">
        <span className="status-number">Nr. {String(number || 0).padStart(3, "0")}</span>
        <span className="status-current" data-testid="status-badge" aria-label={`Status: ${s.label}`}>
          <Circle size={9} fill={s.dot} stroke="none" />
          {loading ? "…" : s.label}
        </span>
        {priceLabel ? <span className="status-price">{priceLabel}</span> : <span />}
      </div>
      {status === "TATTOOED" && hasPhoto ? (
        <button type="button" onClick={onViewPhoto} data-testid="btn-view-tattooed-photo" className="status-photo-link">
          Fertiges Tattoo ansehen
        </button>
      ) : null}
    </div>
  );
};

export default CurioStatusPlate;
